import { Props as HeaderProps } from 'app/components/Common/Header'

export const getHeaderProps = (
  bottomMenuItems: any,
  languagesList: any,
  menuItems: any,
  pageID?: string,
): HeaderProps | undefined => {
  return {
    bottomMenuItems,
    languagesList,
    menuItems,
    pageID,
  }
}
